import { isEscape, returnFocus, trapFocus, throttle } from "./app/utils.js";
import AOS from "aos";
import 'aos/dist/aos.css';
import "./app/navigation.js";
import "./app/sliders.js";
import "./app/product-filter.js";
import "./app/forms.js";
import "./app/accordion.js";
import "./app/videos.js";

var returnFocusTo = window.returnFocusTo || null;
const breakpoints = {
    xs: 0,
    md: 768,
    lg: 1025,
    xl: 1536
};

AOS.init({
    once: true,
    delay: 50,
    offset: 0,
    duration: 750,
    easing: 'ease-in-out',
    mirror: false,
    // anchorPlacement: 'top-bottom',
});

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
    }
});
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const video = document.querySelectorAll('video');
    if (video.length > 0) {
        video.forEach(v => {
            v.pause();
            var videoPauseButton = v.parentElement.querySelector('.video-pause-button');
            videoPauseButton.classList.add('is-paused');
            videoPauseButton.classList.remove('is-playing');
            videoPauseButton.setAttribute('aria-label', 'Play video');
            videoPauseButton.querySelector('span').innerText = 'Play video';
        });
    }
    AOS.init({
        disable: true,
    });
}

/*
Mobile UI
*/
document.getElementById('mobile-navigation-open').addEventListener('click', e => {
    e.preventDefault();

    if(document.body.classList.contains('menu-open')) {
        document.body.classList.remove('menu-open');
        document.getElementById('mobile-navigation-open').classList.remove('active');
        document.getElementById('primary-navigation').classList.remove('active');
    } else {
        document.body.classList.add('menu-open');
        document.getElementById('mobile-navigation-open').classList.add('active');
        document.getElementById('primary-navigation').classList.add('active');
    }
});

/*
Scroll events
*/
// window.addEventListener('scroll', throttle(100, function () {
//     if (window.scrollY > 50) {
//         document.body.classList.add('is-scrolled');
//         return;
//     }
//     document.body.classList.remove('is-scrolled');
// }));
